import React, { useState } from 'react'
import axios from 'axios'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup';
import { useNavigate, Link } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs';

import '../../../styles/Admin.css'

const ADMIN_SYLLABUS_URL = 'admin/auth/syllabus'


const SyllabusSchema = Yup.object().shape({
    semester: Yup.number()
        .positive('Only positive numbers')
        .required('Required'),
    link: Yup.string()
      .min(5, 'Too Short!')
      .required('Required')
});


const AddSyllabus = () => {

    const [loading, setLoading] = useState(false)

    const token = localStorage.getItem('token')
    const navigate = useNavigate()
    const date_published = new Date().toLocaleDateString('en-us', { year: "numeric", month: "short", day: 'numeric' }).replace(',', '')

    return (
        <div className='admin'>
            <div className='section__container'>
                <div className='section'>
                    <Breadcrumbs aria-label="breadcrumb">
                        <Link to="/admin" className='breadcrumb__link'>
                            Admin
                        </Link>
                        <Link to="/admin/syllabus" className='breadcrumb__link'>
                            Syllabus   
                        </Link>
                        <Link to="" className='breadcrumb__link bold'>
                            Add
                        </Link>
                    </Breadcrumbs>
                </div>
                <div className='section'>
                    <h3 className='section__header'>Add Syllabus</h3>
                    <Formik
                        initialValues={{
                            semester: '',
                            link: '',
                            date_published
                        }}
                        validationSchema={SyllabusSchema}
                        onSubmit={async (data) => {
                            setLoading(true)
                            axios.post(`${process.env.REACT_APP_DEPT_API}/${ADMIN_SYLLABUS_URL}/add`, data, {
                                headers: {
                                    authorization: `Bearer ${token}`
                                }
                            }).then(() => {
                                setLoading(false)
                                alert("Added successfully")
                                navigate('/admin/syllabus/')
                            }).catch(err => {
                                console.log(err)
                                alert("Error occured. Check console logs")
                            })
                        }}
                    >
                        {({ errors }) => (
                            <Form className='admin_form_container'>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Semester* </p>
                                    <label htmlFor="semester">
                                        <Field className='admin_input' id="semester" name="semester" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.semester}</p>
                                </div>
                                <div className='admin_input_container'>
                                    <p className='admin_label'>Link* </p>
                                    <label htmlFor="link">
                                        <Field className='admin_input admin_textarea' as="textarea" id="link" name="link" />
                                    </label>
                                    <p className='admin_error_msg'>{errors.link}</p>
                                </div>
                                <button disabled={loading ? true: false} className='admin_btn' type="submit">
                                    {loading ? "Submitting..." : "Submit"}
                                </button>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    )
}

export default AddSyllabus